'use client';

import { useState, useEffect } from 'react';
import { formatBengaliDateTime, formatRelativeBengaliDateTime } from '@/lib/dateUtils';

interface RelativeTimeProps {
    dateStr?: string;
    isManual?: boolean;
    className?: string;
}

export default function RelativeTime({ dateStr, isManual, className = '' }: RelativeTimeProps) {
    // SSR and initial client render use absolute formatted date to prevent hydration mismatch
    const [displayTime, setDisplayTime] = useState(() =>
        dateStr ? formatBengaliDateTime(dateStr, !!isManual) : ''
    );

    useEffect(() => {
        if (!dateStr) return;
        const update = () => {
            setDisplayTime(formatRelativeBengaliDateTime(dateStr, !!isManual));
        };
        update();
        const timer = setInterval(update, 30000); // Update every 30s
        return () => clearInterval(timer);
    }, [dateStr, isManual]);

    return <span className={className}>{displayTime}</span>;
}
